import type { Distribution } from '../../lib/gameData';

/** 1-X-2 crowd-prediction bar. `myPick` ('1'|'X'|'2') brightens the user's lane. */
export function CrowdPicksBar({
  dist,
  myPick,
  showLabels = false,
}: {
  dist: Distribution | null;
  myPick?: '1' | 'X' | '2';
  showLabels?: boolean;
}) {
  const total = dist ? dist.one + dist.x + dist.two : 0;
  const pct = (n: number) => (total > 0 ? Math.round((n / total) * 100) : 33);
  const pO = pct(dist?.one ?? 0);
  const pX = pct(dist?.x ?? 0);
  const pT = pct(dist?.two ?? 0);
  return (
    <div class="bc-crowd">
      <div class="bc-crowd__bar">
        <span class={`bc-crowd__seg one${myPick === '1' ? ' is-mine' : ''}`} style={{ width: `${pO}%` }} />
        <span class={`bc-crowd__seg x${myPick === 'X' ? ' is-mine' : ''}`} style={{ width: `${pX}%` }} />
        <span class={`bc-crowd__seg two${myPick === '2' ? ' is-mine' : ''}`} style={{ width: `${pT}%` }} />
      </div>
      {showLabels && (
        <div class="bc-crowd__labels">
          <span class={myPick === '1' ? 'is-mine one' : ''}>1 · {pO}%</span>
          <span class={myPick === 'X' ? 'is-mine x' : ''}>X · {pX}%</span>
          <span class={myPick === '2' ? 'is-mine two' : ''}>2 · {pT}%</span>
        </div>
      )}
    </div>
  );
}

/** 1 / X / 2 from a predicted scoreline, for highlighting the user's lane. */
export function outcomeOf(scoreA: number, scoreB: number): '1' | 'X' | '2' {
  if (scoreA > scoreB) return '1';
  if (scoreA < scoreB) return '2';
  return 'X';
}
